"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("./hooks");

var _elements = require("../../elements");

var _utils = require("../../utils");

var styles = {
  "select-wrapper": "select-select-wrapper-3xVb5",
  "focused": "select-focused-3ml6f",
  "select-menu": "select-select-menu-EjIta",
  "option": "select-option-1DSs2",
  "option-icon": "select-option-icon-2R8pK",
  "option-selected": "select-option-selected-20QDg",
  "option-value": "select-option-value-1vWUd",
  "prepend-icon": "select-prepend-icon-2D41_",
  "clear-out-button": "select-clear-out-button-1XORg",
  "show": "select-show-3H16k",
  "pure": "select-pure-2Pasv",
  "selectWrapper": "select-select-wrapper-3xVb5",
  "selectMenu": "select-select-menu-EjIta",
  "optionIcon": "select-option-icon-2R8pK",
  "optionSelected": "select-option-selected-20QDg",
  "optionValue": "select-option-value-1vWUd",
  "prependIcon": "select-prepend-icon-2D41_",
  "clearOutButton": "select-clear-out-button-1XORg"
};

var Select = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
      onInput = _ref.onInput,
      onChange = _ref.onChange,
      className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? variant === 'pure' ? label : undefined : _ref$placeholder,
      _ref$prependIcon = _ref.prependIcon,
      prependIcon = _ref$prependIcon === void 0 ? null : _ref$prependIcon,
      _ref$clearButton = _ref.clearButton,
      clearButton = _ref$clearButton === void 0 ? true : _ref$clearButton,
      _ref$clearOnFocus = _ref.clearOnFocus,
      clearOnFocus = _ref$clearOnFocus === void 0 ? false : _ref$clearOnFocus,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? (0, _utils.generateId)() : _ref$id,
      restInputProps = (0, _objectWithoutProperties2["default"])(_ref, ["value", "onInput", "onChange", "className", "children", "label", "variant", "placeholder", "prependIcon", "clearButton", "clearOnFocus", "tag", "id"]);

  // custom select hooks
  var _useInput = (0, _hooks.useInput)(value, {
    onInput: onInput,
    onChange: onChange
  }),
      _useInput2 = (0, _slicedToArray2["default"])(_useInput, 5),
      inputRef = _useInput2[0],
      inputData = _useInput2[1],
      setInputData = _useInput2[2],
      isInputFocused = _useInput2[3],
      setIsInputFocused = _useInput2[4];

  var _useOptions = (0, _hooks.useOptions)(children, {
    selectId: id,
    setIsInputFocused: setIsInputFocused,
    setInputData: setInputData
  }),
      _useOptions2 = (0, _slicedToArray2["default"])(_useOptions, 6),
      selectMenuRef = _useOptions2[0],
      options = _useOptions2[1],
      activeOption = _useOptions2[2],
      setClickedElement = _useOptions2[3],
      handleInputKeyEvent = _useOptions2[4],
      handleInputBlurEvent = _useOptions2[5];

  var handleMouseUp = (0, _react.useCallback)(function (event) {
    var _inputRef$current, _selectMenuRef$curren;

    // detect if click was made outside of select
    // if so hide suggestion menu
    if (((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.contains(event.target)) || ((_selectMenuRef$curren = selectMenuRef.current) === null || _selectMenuRef$curren === void 0 ? void 0 : _selectMenuRef$curren.contains(event.target))) return; // reset keyboard position in option menu

    setClickedElement(null);
    setIsInputFocused(false);
  }, []); // attach event listeners

  (0, _react.useEffect)(function () {
    window.addEventListener('mouseup', handleMouseUp);
    return function () {
      return window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    className: _utils.classNames.use(styles.selectWrapper, isInputFocused && styles.focused).join(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sr-only",
    "aria-live": "assertive"
  }, options.length && document.activeElement === inputRef.current ? "".concat(options.length, " suggestions found, to navigate use up and down arrows") : ''), /*#__PURE__*/_react["default"].createElement(_elements.Form.Group, {
    tag: "div",
    className: variant === 'pure' ? styles.pure : ''
  }, prependIcon && /*#__PURE__*/_react["default"].createElement(_elements.Form.Addon, {
    place: "prepend",
    className: styles.prependIcon
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    src: prependIcon
  })), clearButton && /*#__PURE__*/_react["default"].createElement(_elements.Form.Addon, {
    place: "append"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Button, {
    className: _utils.classNames.use(styles.clearOutButton, inputData.value && styles.show),
    onClick: function onClick() {
      setInputData({
        value: ''
      });
      inputRef.current.focus();
    }
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    src: "#window-close"
  }))), /*#__PURE__*/_react["default"].createElement(_elements.Form.Control, (0, _extends2["default"])({
    ref: inputRef,
    id: "select-".concat(id),
    type: "text",
    placeholder: placeholder,
    autoComplete: "off",
    role: "combobox",
    "aria-expanded": Boolean(options.length),
    "aria-owns": "suggestion-results",
    "aria-autocomplete": "both",
    "aria-controls": "suggestion-results-".concat(id),
    "aria-activedescendant": (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id) ? "suggestion-result-".concat(id, "-").concat(activeOption.id) : undefined,
    value: inputData.value,
    onFocus: function onFocus() {
      setIsInputFocused(true);
      if (clearOnFocus) setInputData({
        value: ''
      });
    },
    onBlur: handleInputBlurEvent,
    onKeyDown: handleInputKeyEvent,
    onChange: function onChange(event) {
      if (inputData.value === event.target.value) return;
      setInputData({
        value: event.target.value
      });
    }
  }, restInputProps)), /*#__PURE__*/_react["default"].createElement(_elements.Form.Label, {
    htmlFor: "select-".concat(id)
  }, label)), /*#__PURE__*/_react["default"].createElement("ul", {
    id: "suggestion-results-".concat(id),
    className: _utils.classNames.use(styles.selectMenu, (0, _defineProperty2["default"])({}, styles.show, isInputFocused)),
    role: "listbox",
    ref: selectMenuRef
  }, options));
});

Select.propTypes = {
  /* Label to show in input */
  label: _propTypes["default"].string.isRequired,

  /* The current value shown in input field */
  value: _propTypes["default"].string,

  /* Callback function called whenever input changes */
  onInput: _propTypes["default"].func,

  /* Callback function called whenever input loses focus */
  onChange: _propTypes["default"].func,

  /* Custom classname applied on select wrapper */
  className: _propTypes["default"].string,

  /* Icon to prepend before input */
  prependIcon: _propTypes["default"].string,

  /* Indicates whether clear button is shown */
  clearButton: _propTypes["default"].bool,

  /* Indicates whether input should be clear onFocus */
  clearOnFocus: _propTypes["default"].bool,

  /* Input's placeholder */
  placeholder: _propTypes["default"].string,

  /**
   * Helper variation. Affects label display.
   *
   * If variant is pure label is shown only when select is not focused
   */
  variant: _propTypes["default"].oneOf(['normal', 'pure'])
};
Select.defaultProps = {
  prependIcon: null,
  clearButton: true,
  clearOnFocus: false
};
var _default = Select;
exports["default"] = _default;